"use client";

import {cn} from '@/lib/utils';
import Image, {StaticImageData} from 'next/image';
import {GROQImage} from "@/sanity/lib/types";

export default function ChipStatue({
  text1,
  text2,
  image,
  className = '',
}: {
  text1?: string;
  text2?: string;
  image: string | StaticImageData;
  className?: string;
}) {
  const currentYear = new Date().getFullYear().toString();
  const firstDigits = currentYear.slice(0, 2);
  const lastDigits = currentYear.slice(2, 4);

  if (!image) return null;

  return (
    <div className={cn(
      "w-full flex items-end justify-center gap-[2rem]",
      className
    )}>
      <p className="mb-0 h-[13.5rem] lg:h-[15rem] flex-1 text-[#B78768] font-instrument text-[2.25rem] flex items-center justify-end">
        {text1 ? text1 : firstDigits}
      </p>

      {image && (
        <Image
          className="!w-[13.5rem] lg:!w-[15rem]"
          src={image}
          alt=""
        />
      )}

      <p className="mb-0 h-[13.5rem] lg:h-[15rem] flex-1 text-[#B78768] font-instrument text-[2.25rem] flex items-center justify-start">
        {text2 ? text2 : lastDigits}
      </p>
    </div>
  );
}
